import { Box, SxProps } from '@mui/material';
import { TooltipProps } from '../../mui-builder/Tooltip/Tooltip';
import { FieldProps } from '../types';
import TextField, { TextFieldValue } from './TextField';
import { useUiTheme } from 'framework/uiTheme';
import FormattedTextField from './FormattedTextField';

const TextFieldWithPrefix = ({
  tooltipProps,
  boxSx,
  format,
  ...props
}: FieldProps<TextFieldValue> & {
  tooltipProps?: TooltipProps;
  boxSx?: SxProps;
  format?: (value: any) => any;
}) => {
  const { Tooltip } = useUiTheme();
  const FieldComponent = format ? FormattedTextField : TextField;

  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', gap: 1, alignItems: 'center', ...boxSx }}>
      {tooltipProps && <Tooltip {...tooltipProps} />}
      <FieldComponent {...props} format={format} />
    </Box>
  );
};

export default TextFieldWithPrefix;
